const apiConfigs = {
  "regional": {
    "apiHost": "https://api-dev.mit.edu",
    "paths": {
      "account": "account-v2",
      "digitalId": "digital-id-v1"
    }
  },
  "global": {
    "apiHost": "https://account-admin-dev.mit.edu/api",
    "paths": {
      "account": "account/v3",
      "digitalId": "digital-id/v1"
    }
  }
};
export default apiConfigs;